
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.71 13.71a.57.57 0 00-.35-.36A21.469 21.469 0 0030.15 7C17.6 7 8 17.78 8 30a23.06 23.06 0 006.51 16.2c.12.31.28.51.49.49a22.64 22.64 0 0015.15 6.34 22.76 22.76 0 0022.14-23 23.55 23.55 0 00-6.58-16.32zm-15.56-3.56a21.12 21.12 0 0113.33 4.84L15.01 43.43a18.781 18.781 0 01-5.62-13.4c0-11.1 9.96-19.88 20.76-19.88zm0 39.76a22.64 22.64 0 01-13.33-4.87l28.44-28.41a19.6 19.6 0 015.58 12.27c.78 11.84-9.54 20.66-20.69 21.01z"}})])
          )
        }
      }
    